import * as yup from "yup";

import * as RHFUserValidationRules from "@/utils/validation/schemas/user.RHF";

export const EditPasswordFormValidationSchema = yup.object({
    oldPassword: RHFUserValidationRules.password,
    newPassword: RHFUserValidationRules.password,
    newPasswordRepeat: RHFUserValidationRules.passwordRepeat
});

export type EditPasswordFormValues = yup.InferType<
    typeof EditPasswordFormValidationSchema
>;
